import { Plugin } from './Plugin';
import { ScenePlugin } from './ScenePlugin';
import { EntityPlugin } from './EntityPlugin';
import { MousePlugin } from './MousePlugin';
import { MoveCursor } from '../objects';
import { Raycaster, Vector2, Vector3, Euler, Object3D, Quaternion, MeshBasicMaterial } from 'three';
import gsap from 'gsap';

// import { Stats } from 'libs';
// const stats = new Stats();

const tmp2 = new Vector2();
const tmp3 = new Vector3();
const sqrt2 = Math.sqrt(2);

export class RotatePlugin extends Plugin{
	constructor(manager){
		super(manager);

		this.dependencies.add(MousePlugin);
		this.dependencies.add(ScenePlugin);
		this.dependencies.add(EntityPlugin);

		this.rotateDelta = new Vector2();

		this.euler 		= new Euler(0, 0, 0, 'YXZ');
		this.quaternion = new Quaternion();


		this.rotateSpeed		= 0.5;
		this.rotationDamping	= 0.1;

		this.minYRotation	= -0.7;
		this.maxYRotation	= 0.4;

		this.requestRenderAngle =  Math.PI/180 * 0.01;

		this.dragging = false;

		this.rotating = false;
	}

	get scene(){ return this.manager.get(ScenePlugin).scene; }
	get camera(){ return this.viewer.rendering.camera; }
	get scenePlugin(){ return this.manager.get(ScenePlugin); }
	get mouse(){ return this.manager.get(MousePlugin); }

	attach(){
		this.viewer.rendering.ticker.on('tick', this.render);
		this.scenePlugin.on('scene-changed', this.onSceneChange);

		this.viewer.on('resize', this.onResize);

		this.mouse.on('down', this.onMouseDown);
		this.mouse.on('up', this.onMouseUp);
		this.mouse.on('move', this.onMouseMove);
	}

	detach(){
		this.dragging = false;

		this.viewer.rendering.ticker.off('tick', this.render);
		this.scenePlugin.off('scene-changed', this.onSceneChange);

		this.viewer.off('resize', this.onResize);

		this.mouse.off('down', this.onMouseDown);
		this.mouse.off('up', this.onMouseUp);
		this.mouse.off('move', this.onMouseMove);
	}

	onResize = () => {
		if(this.viewer.viewport.width < 768)
			this.rotateSpeed = 0.1;
		else if(this.viewer.viewport.width < 1280)
			this.rotateSpeed = 0.2;
		else this.rotateSpeed = 0.5;

	}

	onSceneChange = (scene) => {
		this.euler.setFromQuaternion(this.camera.quaternion);
		this.quaternion.copy(this.camera.quaternion);
		this.viewer.requestRender();
	}

	onMouseDown = (e) => {
		this.dragging = true;
		this.clickPrevented = false;
	}

	onMouseUp = (e) => {
		this.dragging = false;
		this.rotateDelta.set(this.mouse.speed.x, -this.mouse.speed.y);

		if(tmp2.subVectors(this.mouse.end, this.mouse.start).multiplyScalar(this.viewer.rendering.width/2).length() > 10){
			e.preventDefault();
			this.clickPrevented = true;
		}
	}

	onMouseMove = (e) => {
		if(this.dragging){
			this.rotateDelta.set(this.mouse.speed.x, -this.mouse.speed.y).multiplyScalar(this.rotateSpeed * 2 * Math.PI);

			this.euler.x += this.rotateDelta.y;
			this.euler.y += this.rotateDelta.x;

			this.euler.x = Math.max(this.minYRotation, Math.min(this.maxYRotation, this.euler.x))

			this.quaternion.setFromEuler(this.euler);
			this.viewer.requestRender();
		}
	}

	focus(pin){
		const clone = this.camera.clone();
		if(pin && pin.camera && pin.camera.rotation
		&& (pin.camera.rotation.x != 0 || pin.camera.rotation.y != 0 || pin.camera.rotation.z != 0 )){
			clone.rotation.set(
				pin.camera.rotation.x,
				pin.camera.rotation.y,
				pin.camera.rotation.z,
			);
		}
		else{
			pin.getWorldPosition(tmp3);
			clone.lookAt(tmp3);
		}

		this.quaternion.copy(clone.quaternion);
		this.euler.setFromQuaternion(clone.quaternion);

		gsap.fromTo(this, {rotationDamping:0}, {rotationDamping:0.1, duration:1.5, ease:'quint.in'})
	}

	render = () => {
		if(this.scene){
			if(this.rotating){
				this.viewer.requestRender()
			}
			this.camera.quaternion.slerp(this.quaternion, this.rotationDamping);
			this.rotating = this.quaternion.angleTo(this.camera.quaternion) > this.requestRenderAngle;
		}
	}
}